module.exports = __webpack_public_path__ + "img/logo.ea0d2294.png";